import React from 'react'
import SingleCollectionComp from '../../components/explore/singleCollection/SingleCollectionComp'

const SingleCollectionScreen = () => {
    return (
        <>
            <SingleCollectionComp />
        </>
    )
}

export default SingleCollectionScreen